import BaseController from "sap/mcsuite/controller/BaseController";
import LogHandler from "../handlers/LogHandler";
import Control from "sap/ui/core/Control";

export default abstract class Subtask {
    protected metadata: SubtaskMetadata;
    protected controller: BaseController;
    protected subtaskId: string;
    protected eventHandlers: { [key: string]: () => (void | Promise<void>)} = {};

    constructor(controller: BaseController, subtaskId: string) {
        this.metadata = {
            name: "Subtask",
            subtaskId: subtaskId
        };
        this.controller = controller;
        this.subtaskId = subtaskId;
    }

    protected attachHandlers(): void {
        for (const fnName in this.eventHandlers) {
            const handler = this.eventHandlers[fnName];
            try {
                // When the handler is a FFunction, we can use async/await
               const result = handler();
               if (result instanceof Promise) {
                    result.catch(error => {
                        console.error(`Error in event handler ${fnName}:`, error);
                    });
                }
            }
            catch (error) {
                console.error(`Error attaching event handler ${fnName}:`, error);
            }
        }
    }

    protected waitForBindingReady(
        control: Control,
        bindingPath: string,
        callback: () => void
    ): void {
        let isCallbackCalled = false;

        const executeCallback = () => {
            if (!isCallbackCalled) {
                isCallbackCalled = true;
                callback();
                LogHandler.display(`Callback executed for binding path: ${bindingPath}`);
            }
        };

        const binding = control.getBinding(bindingPath);
        if (binding && binding.isResolved()) {
            executeCallback();
        } else {
            control.attachModelContextChange(() => {
                const updatedBinding = control.getBinding(bindingPath);
                if (updatedBinding && updatedBinding.isResolved()) {
                    executeCallback();
                }
            }, this);
        }
    }

    protected getSubtaskControl(): Control {
        return this.controller.getView().byId(this.subtaskId) as Control;
    }

    protected getUIElementByNameInSubtask(name: string): Control {
        return this.controller.getView().byId(`${this.subtaskId}-${name}`) as Control;
    }

}

export type SubtaskMetadata = {
    name: string;
    subtaskId: string;
};